import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
// const protocol = window.location.protocol
const host = window.location.host
const reg = /^localhost+/
let url = ''

// 判斷網址不是localhost時，baseURL = VUE_APP_API192
// 讓Network(192.168...)也能連正確api
if (reg.test(host)) {
  url = process.env.VUE_APP_API
} else url = process.env.VUE_APP_API192
// console.log(url)

export const api = axios.create({
  baseURL: url
})
export const geawapi = axios.create({
  baseURL: process.env.VUE_APP_API_GEAW
})

Vue.use(VueAxios, { axios, api, geawapi })
